import React, { useState } from 'react';
import { addComment } from '@api/comment';
import { ImageType } from '@typings/Image';
import { ApiResponse } from '@typings/ApiResponse';
import { CommentType } from '@typings/Comment';
import Editor from '../react-quill/Editor';
import ListImages from './AddImagesList';
import './styles.scss';

interface AddCommentProps {
  slug: string | undefined;
  onCommentAdded: () => void;
}

const AddComment: React.FC<AddCommentProps> = ({ slug, onCommentAdded }) => {
  const [images, setImages] = useState<ImageType[]>([]);
  const [content, setContent] = useState<string>('');
  const [safeGuardingConcerns, setSafeGuardingConcerns] = useState('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const removeImage = (id?: number) => {
    setImages(images.filter(image => image.id !== id));
  };

  const handleAddComment = async () => {
    setIsLoading(true);
    const imageList = images.map(({ key, bucket, mimetype, size }) => ({
      key,
      bucket,
      mimetype,
      size,
    }));

    if (slug) {
      try {
        const response: ApiResponse<CommentType> = await addComment(
          content,
          imageList,
          safeGuardingConcerns || null,
          slug
        );
        if (response && response.status === 'success') {
          onCommentAdded();
          setContent('');
          setImages([]);
          setSafeGuardingConcerns('');
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div>
      <Editor setImages={setImages} content={content} setContent={setContent} />
      {images?.length !== 0 && (
        <ListImages images={images} removeImage={removeImage} />
      )}
      <div className="govuk-form-group mt-5">
        <h3 className="govuk-label-wrapper">
          <label
            className="govuk-label govuk-label--s"
            htmlFor="safeGuardingInput"
          >
            Safeguarding concerns
          </label>
        </h3>
        <div id="safeguarding-input-hint" className="govuk-hint">
          If there is a safeguarding concern please log the concern in the box
          below before adding your comment.
        </div>
        <input
          className="govuk-input govuk-input--width-20"
          id="safeGuardingInput"
          name="safeGuardingConcerns"
          type="text"
          placeholder="Add safeguarding concern"
          aria-describedby="safeguarding-input-hint"
          value={safeGuardingConcerns}
          onChange={e => setSafeGuardingConcerns(e.target.value)}
        />
      </div>
      <button
        type="submit"
        className="govuk-button"
        data-module="govuk-button"
        onClick={handleAddComment}
        disabled={isLoading}
      >
        Add comment
      </button>
    </div>
  );
};

export default AddComment;
